import React from 'react';

interface Props {
  height?: number;
  className?: string;
}

export default function GoalCastLogo({ height = 44, className }: Props) {
  const uid = React.useId().replace(/:/g, '');
  const sg  = `sg-${uid}`;
  const bg  = `bg-${uid}`;

  return (
    <svg
      height={height}
      viewBox="0 0 680 520"
      role="img"
      aria-label="TopQik"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: 'auto', background: 'transparent', overflow: 'visible', display: 'block' }}
      className={className}
    >
      <defs>
        <linearGradient id={sg} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stopColor="#F97316" />
          <stop offset="100%" stopColor="#EC4899" />
        </linearGradient>
        <linearGradient id={bg} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#ffffff" />
          <stop offset="100%" stopColor="#f0e0d0" />
        </linearGradient>
      </defs>

      <path d="M340,52 L512,95 L512,282 Q512,410 340,472 Q168,410 168,282 L168,95 Z"
            fill="none" stroke="#F97316" strokeWidth="3" opacity="0.4" />
      <path d="M340,60 L500,100 L500,280 Q500,400 340,460 Q180,400 180,280 L180,100 Z"
            fill="#1a0d00" />
      <path d="M340,68 L492,106 L492,279 Q492,393 340,451 Q188,393 188,279 L188,106 Z"
            fill="none" stroke="#F97316" strokeWidth="2.5" opacity="0.9" />
      <path d="M340,74 L486,110 L486,278 Q486,387 340,444 Q194,387 194,278 L194,110 Z"
            fill="#0F0A14" />

      <circle cx="340" cy="210" r="88" fill={`url(#${bg})`} />

      <polygon points="340,145 358,163 351,185 329,185 322,163" fill="#1a0d00" opacity="0.85" />
      <polygon points="390,172 408,190 401,212 379,212 372,190" fill="#1a0d00" opacity="0.85" />
      <polygon points="290,172 308,190 301,212 279,212 272,190" fill="#1a0d00" opacity="0.85" />
      <polygon points="375,235 393,253 386,275 364,275 357,253" fill="#1a0d00" opacity="0.85" />
      <polygon points="305,235 323,253 316,275 294,275 287,253" fill="#1a0d00" opacity="0.85" />

      <polygon points="300,295 305,310 320,310 308,319 313,334 300,325 287,334 292,319 280,310 295,310"
               fill={`url(#${sg})`} opacity="0.9" />
      <polygon points="340,288 346,306 365,306 350,317 356,335 340,324 324,335 330,317 315,306 334,306"
               fill={`url(#${sg})`} />
      <polygon points="380,295 385,310 400,310 388,319 393,334 380,325 367,334 372,319 360,310 375,310"
               fill={`url(#${sg})`} opacity="0.9" />

      <rect x="168" y="335" width="344" height="62" fill="#0F0A14" />
      <line x1="168" y1="335" x2="512" y2="335" stroke="#F97316" strokeWidth="2" />
      <line x1="168" y1="397" x2="512" y2="397" stroke="#EC4899" strokeWidth="2" />

      <text x="340" y="378" textAnchor="middle"
            fontFamily="Arial Black, Arial, sans-serif"
            fontSize="36" fontWeight="900" letterSpacing="4"
            fill={`url(#${sg})`}>
        TOPQIK
      </text>

      <rect x="220" y="397" width="240" height="30" fill="#F97316" />
      <text x="340" y="418" textAnchor="middle"
            fontFamily="Arial, sans-serif"
            fontSize="13" fontWeight="700" letterSpacing="5"
            fill="#0F0A14">
        LET&apos;S PLAY
      </text>

      <polygon points="340,435 344,447 357,447 347,455 351,467 340,459 329,467 333,455 323,447 336,447"
               fill={`url(#${sg})`} />
    </svg>
  );
}
